const generateRandomKey = () =>
  `_${Math.random()
    .toString(36)
    .substr(2, 9)}`

export default generateRandomKey



// WEBPACK FOOTER //
// ./src/utils/generateRandomKey.js